import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  /* Container */
  root: {
    padding: '24px 24px 24px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    boxSizing: 'border-box',
  },

  /* Title */
  title: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    color: 'rgba(43, 44, 53, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },

  /* Empty state */
  emptyWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    border: '1px solid #e9ebf5',
  },
  emptyText: {
    fontSize: 14,
    fontWeight: 400,
    color: 'rgba(95, 96, 113, 1)',
    textAlign: 'center',
  },

  /* ================== Breakpoints ================== */

  /* ≤1440px */
  '@media (max-width:1440px)': {
    root: { padding: 22, gap: 8 },
    title: { fontSize: 13, lineHeight: '20px' },
    emptyWrap: { padding: 18 },
    emptyText: { fontSize: 13 },
  },

  /* ≤1280px */
  '@media (max-width:1280px)': {
    root: { padding: 20, gap: 8 },
    title: { fontSize: 13, lineHeight: '20px' },
    emptyWrap: { padding: 16 },
    emptyText: { fontSize: 13 },
  },

  /* ≤1024px */
  '@media (max-width:1024px)': {
    root: { padding: 16, gap: 8 },
    title: { fontSize: 12, lineHeight: '18px' },
    emptyWrap: { padding: 14 },
    emptyText: { fontSize: 12 },
  },
}));

export default useStyles;
